import { Container } from '@global-engineering-shared/gweb-material-ui';
import { useEffect } from 'react';

import TableContainer from 'components/EntityListTable/components/TableContainer';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import EntitiesTablePageHeader from 'features/Entities/components/EntitiesTablePageHeader';
import { useEntitiesTables } from 'features/Entities/utils';
import { FilterType } from 'features/Filters/types/Filters';
import { SEARCH_TERM } from 'utils/defaults';

const EntitiesPage = () => {
  const { searchParams } = useSearchParamsProvider();
  const searchTerm = searchParams.get(SEARCH_TERM) ?? '';

  const { setCurrentFiltersPage } = useFilters();
  useEffect(() => {
    setCurrentFiltersPage(FilterType.LIVE_ENTITIES);
  }, []);

  const tablesConfig = useEntitiesTables();

  return (
    <main>
      <Container maxWidth="lg">
        <TableContainer
          tablesConfig={tablesConfig}
          tableHeader={<EntitiesTablePageHeader searchTerm={searchTerm} />}
        />
      </Container>
    </main>
  );
};

export default EntitiesPage;
